var _recaptchaOnLoading=false;
export default function loadReCaptchaScript() {
    if(!_recaptchaOnLoading){
        _recaptchaOnLoading=true;
        var script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=6LdiOUMoAAAAADn0sXowEnEbPJpt-YU_AmZAehdx';
        document.head.appendChild(script);
    }
}